import update from "immutability-helper";
import {
  UPDATE,
  GET,
  ADD,
  ON_SUBMIT,
  DELETE,
  QUERY,
  GET_PERMISSIONS
} from "./constants";
import { Intent } from "@blueprintjs/core";
import { AppToaster } from "app/toaster";
import { next, ids } from "app/utils";
import { parse } from "date-fns";

const initialState = {
  proposalsById: {},
  actions: { [GET]: {} }
};

const toasts = {
  [UPDATE.ERROR]: {
    iconName: "warning-sign",
    message: props => `${props.message}. Are you logged in?`,
    intent: Intent.DANGER
  }
};

const showToast = (type, data) => {
  const toast = { ...toasts[type] };
  if (toast) {
    if (typeof toast.message === "function") {
      toast.message = toast.message(data);
    }
    AppToaster.show(toast);
  }
};

const getProposalPath = props => {
  const { topicId, _id } = props;
  return `/topics/${topicId}/p/${_id}`;
};

const mergeUi = (proposal, collection) => {
  const path = getProposalPath(proposal);
  const isSampleData = !("userId" in proposal);
  let isDraft = !proposal.draftId;
  if (collection) {
    isDraft = collection === "drafts";
  }
  let user = {};
  if (!isSampleData) {
    user.userId = proposal.userId;
  }
  const brief =
    proposal.shortDescription ||
    `${(proposal.description || "").slice(0, 100)}...`;
  const sortableDate = isSampleData ? parse(0) : parse(proposal.modified || 0);
  const ui = {
    ...proposal.ui,
    path,
    brief,
    isSampleData,
    isDraft,
    user,
    sortableDate
  };
  proposal.ui = ui;
  return proposal;
};

const normalizeProposal = (proposal, collection) => {
  if (!proposal.content) {
    proposal.content = { objects: [] };
  }
  let objs = proposal.content.objects || [];
  objs = objs.map(obj => {
    if (obj.id) return obj;
    return { ...obj, id: next(ids) };
  });
  return mergeUi(
    update(proposal, {
      $merge: {
        brief:
          proposal.shortDescription ||
          `${(proposal.description || "").slice(0, 100)}...`
      },
      content: {
        objects: {
          $set: objs
        }
      }
    }),
    collection
  );
};

const handleGetSuccess = (state, action, collection) => {
  return update(state, {
    proposalsById: {
      $merge: { [action.data._id]: normalizeProposal(action.data, collection) }
    },
    actions: { [GET]: { [action.payload.params.proposalId]: { $set: action } } }
  });
};

const handleGetPermissionSuccess = (state, action, value) => {
  let permission = action.payload.params.permission,
    proposalId = action.payload.params.proposalId,
    proposalsById = state.proposalsById || {},
    proposal = proposalsById[proposalId] || {},
    permissions = proposal.permissions || {};

  permissions = update(permissions, {
    $merge: {
      [permission]: value
    }
  });
  proposal = update(proposal, {
    $merge: { permissions }
  });
  proposalsById = update(proposalsById, {
    $merge: {
      [proposalId]: proposal
    }
  });
  return update(state, {
    $merge: { proposalsById }
  });
};

export default (state = initialState, action) => {
  let proposalsById;
  const { type, data, payload } = action;
  switch (type) {
    case GET.PENDING:
      return update(state, {
        actions: {
          [GET]: { [payload.params.proposalId]: { $set: action } }
        }
      });
    case GET.SUCCESS:
      return handleGetSuccess(state, action, payload.collection);
    case GET.ERROR:
      return update(state, {
        actions: {
          [GET]: { [payload.params.proposalId]: { $set: action } }
        }
      });
    case ADD.SUCCESS:
      proposalsById = {
        ...state.proposalsById,
        [data._id]: normalizeProposal(data, payload.collection)
      };
      return { ...state, proposalsById };
    case ON_SUBMIT.SUCCESS:
      proposalsById = {
        ...state.proposalsById,
        [data._id]: normalizeProposal(data, payload.collection)
      };
      return { ...state, proposalsById };
    case UPDATE.SUCCESS:
      proposalsById = {
        ...state.proposalsById,
        [payload.proposal._id]: normalizeProposal(
          payload.proposal,
          payload.collection
        )
      };
      return { ...state, proposalsById };
    case UPDATE.ERROR:
      showToast(type, data);
      return state;
    case QUERY.SUCCESS:
      proposalsById = {};
      for (let proposal of data) {
        proposalsById[proposal._id] = normalizeProposal(
          proposal,
          payload.collection
        );
      }
      return update(state, {
        proposalsById: {
          $merge: proposalsById
        }
      });
    case DELETE.SUCCESS:
      return update(state, {
        proposalsById: { $unset: [action.payload.proposalId] }
      });
    case GET_PERMISSIONS.SUCCESS:
      return handleGetPermissionSuccess(state, action, true);
    case GET_PERMISSIONS.ERROR:
      // We need to use this action for the moment since the permission
      // service returns status code 403 if the permission was denied.
      return handleGetPermissionSuccess(state, action, false);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/proposals/reducers.js